/* JustSmoke mega menu: "MORE" overflow (v1).
   When the 16 top-level items do not fit on one row (about 992-1359px), the items that do not fit are MOVED
   (not cloned) into a tray under a "MORE" item, so their mega panels, hover handlers and accents keep working.
   Markup comes from snippets/main-menu-jsmega.liquid; hover/panel logic stays in jsmega-menu.js.
   Without this script the CSS fallback in js-header-fit-v1.css (two rows below 1360px) still applies. */
(function () {
  'use strict';

  var MQ = window.matchMedia('(min-width: 992px)');
  var HOVER = window.matchMedia('(hover: hover)');
  var CHEVRON = '<svg class="jsmega__chevron" width="9" height="5" viewBox="0 0 9 5" aria-hidden="true" focusable="false"><path d="M1 1l3.5 3L8 1" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var states = [];
  var queued = false;

  function build(nav) {
    if (nav.__jsmegaMore) return;
    var list = nav.querySelector('.jsmega__toplist');
    if (!list || !list.children.length) return;

    var items = Array.prototype.slice.call(list.children);
    var more = document.createElement('li');
    more.className = 'jsmega__topitem jsmega__more';
    more.hidden = true;
    more.style.setProperty('--item-accent', '#f4df23');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'jsmega__toplink jsmega__more-link';
    btn.setAttribute('aria-haspopup', 'true');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span>MORE</span>' + CHEVRON;

    var tray = document.createElement('div');
    tray.className = 'jsmega__more-tray';

    more.appendChild(btn);
    more.appendChild(tray);
    list.appendChild(more);

    var state = { nav: nav, list: list, items: items, more: more, btn: btn, tray: tray, frozen: false, row: null, rows: 1, cols: 10, arrows: [] };
    nav.__jsmegaMore = state;
    states.push(state);

    // Row arrows: one row of tiles shows at a time; up/down arrows on both sides step between rows.
    var bar = nav.querySelector('.jsmega__bar');
    if (bar) {
      ['left', 'right'].forEach(function (side) {
        var box = document.createElement('div');
        box.className = 'jsmega__rownav jsmega__rownav--' + side;
        [['up', '▲', 'Previous menu row', -1], ['down', '▼', 'Next menu row', 1]].forEach(function (d) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'jsmega__rowbtn jsmega__rowbtn--' + d[0];
          b.setAttribute('aria-label', d[2]);
          b.textContent = d[1];
          b.addEventListener('click', function () { stepRow(state, d[3]); });
          box.appendChild(b);
          state.arrows.push({ btn: b, dir: d[3] });
        });
        bar.appendChild(box);
      });
    }

    function setOpen(open) {
      more.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    btn.addEventListener('click', function (event) {
      if (event.pointerType === 'touch' || !HOVER.matches) {
        setOpen(!more.classList.contains('is-open'));
      }
    });
    document.addEventListener('click', function (event) {
      if (!more.contains(event.target)) setOpen(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });
  }

  // Make the dark bar span exactly the visible viewport (excluding the page scrollbar), whatever the header container offset is.
  // .jsmega is a flex container, so flex:none stops the bar being shrunk to the (narrower) header column.
  function fitBar(state) {
    var bar = state.nav.querySelector('.jsmega__bar');
    if (!bar) return;
    var left = state.nav.getBoundingClientRect().left;
    var cw = document.documentElement.clientWidth + 'px';
    bar.style.setProperty('width', cw, 'important');
    bar.style.setProperty('min-width', cw, 'important');
    bar.style.setProperty('max-width', 'none', 'important');
    bar.style.setProperty('flex', 'none', 'important');
    bar.style.setProperty('margin-left', (-left) + 'px', 'important');
    bar.style.setProperty('margin-right', '0', 'important');
  }

  // Show only the tiles of the active row (10 per row); the rest are hidden with .jsmega__rowhide.
  // The menu always opens on the first row; the arrows step to the others.
  function applyRows(state) {
    var cols = getComputedStyle(state.list).gridTemplateColumns.split(' ').length || 10;
    var total = state.items.length;
    var rows = Math.max(1, Math.ceil(total / cols));
    if (state.row === null) state.row = 0;
    state.row = Math.min(Math.max(0, state.row), rows - 1);
    state.cols = cols;
    state.rows = rows;
    state.items.forEach(function (li, i) {
      li.classList.toggle('jsmega__rowhide', Math.floor(i / cols) !== state.row);
    });
    state.nav.classList.toggle('jsmega--has-rows', rows > 1);
    state.arrows.forEach(function (a) {
      var off = (a.dir < 0 && state.row <= 0) || (a.dir > 0 && state.row >= rows - 1);
      a.btn.disabled = off;
    });
  }

  function stepRow(state, dir) {
    state.row = (state.row === null ? 0 : state.row) + dir;
    applyRows(state);
  }

  function layout(state) {
    if (!MQ.matches) return;
    var list = state.list;
    var items = state.items;
    var more = state.more;

    // Freeze each item's nth-child accent colour once, so moving it into the tray keeps its colour.
    if (!state.frozen) {
      items.forEach(function (li) {
        var value = getComputedStyle(li).getPropertyValue('--item-accent').trim();
        if (value) li.style.setProperty('--item-accent', value);
      });
      state.frozen = true;
    }

    // Reset: every item back in the main row, in original order.
    items.forEach(function (li) { list.insertBefore(li, more); });
    more.hidden = true;
    more.classList.remove('is-current');

    // Grid mode (10 tiles per row, see js-menu-more-v1.css): everything is visible, so no MORE overflow is needed.
    if (getComputedStyle(list).display === 'grid') {
      state.nav.classList.remove('jsmega--more-ready');
      fitBar(state);
      applyRows(state);
      return;
    }
    state.nav.classList.add('jsmega--more-ready');

    var available = list.clientWidth;
    if (!available) return;
    var gap = parseFloat(getComputedStyle(list).columnGap) || 0;

    function used() {
      var width = 0;
      var count = 0;
      Array.prototype.forEach.call(list.children, function (child) {
        if (child.hidden) return;
        width += child.getBoundingClientRect().width;
        count++;
      });
      return width + gap * Math.max(0, count - 1);
    }

    if (used() <= available - 1) return;

    more.hidden = false;
    for (var i = items.length - 1; i > 0 && used() > available - 1; i--) {
      state.tray.insertBefore(items[i], state.tray.firstChild);
    }
    if (state.tray.querySelector('.is-current')) more.classList.add('is-current');
  }

  function layoutAll() {
    queued = false;
    states.forEach(layout);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(layoutAll);
  }

  function init() {
    document.querySelectorAll('.jsmega').forEach(build);
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  document.addEventListener('shopify:section:load', function () { states = []; init(); });
  if (window.ResizeObserver) {
    var observer = new ResizeObserver(schedule);
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.jsmega').forEach(function (nav) { observer.observe(nav); });
    }, { once: true });
  }
})();
